<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import { useUserStore } from '@/stores/userStore'
import { followListAPI } from '@/apis/user'
import { setDelfollowApi, setAddfollowApi } from '@/apis/detail'
import { onMounted, ref } from 'vue'
import { maskName } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
const router = useRouter()
const { t } = useI18n();
const userStore = useUserStore()
const followList = ref([])
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getFollowList()
})
const total=ref()
const reqData = ref({
    page: 1,
    pageSize: 20,
})
const getFollowList = async () => {
    const res = await followListAPI(reqData.value)
    followList.value = res.data.data
    total.value=res.data.total

}
const loading = ref(false)
const noMore = computed(() => {
    if(followList.value){
        console.log('111',followList.value)
       if(followList.value.length >= total.value) {
        return true;
       }else{
        return false;
       }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        reqData.value.page++
        const res = await followListAPI(reqData.value)
        if (res.data.data) {
            followList.value = [...followList.value, ...res.data.data]
           
        }
        total.value=res.data.total
        loading.value = false
    }, 10)
}
const delfollow = (value) => {
    ElMessageBox.confirm(
        t('home32'),
        {
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK',
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await setDelfollowApi({ followId: value.id })
            if (res.code == 0) {
                ElMessage({ type: 'success', message: t('home41') })
                userStore.getUser()
                value.but = false
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t('home33'),
            })
        })

}
const Addfollow = async (value) => {

    const res = await setAddfollowApi({ followId: value.id })
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('home34') })
        userStore.getUser()
        value.but = true
    } else {
        ElMessage({ type: 'error', message: res.message })
    }

}
const value = ref(4.0)
</script>

<template>
     <TitleComponent :title="t('number103')" v-if="isMobile==true"></TitleComponent>
    <div class="historyPage">
       
        <div class="home-panel">
            <div class="header pc" v-if="isMobile==false">
                <div class="header-title" data-v-bcb266e0="">{{$t('number103')}}</div>
                <div>
                    <!-- {{ total }} -->
                </div>
            </div>
            <!-- 暂无数据 -->
            <div class="cart-none" v-if="followList.length === 0">
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>
            <!-- 有数据 -->
            <div class="goods-list" v-else>
                <div class="MyFollowers" v-if="isMobile==true">{{$t('number103')}}（{{total}}）</div>
                <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">

                    <div class="list-item" v-for="(item, i) in followList" :key="i">
                        <div class="item-user">
                            <!-- @click="router.push('/userDetails/' + item.id)" -->
                            <div class="avatar-container">
                                <img :src="item.avatar" alt="User Avatar" class="avatar">
                            </div>
                            <div class="name">

                                <div>{{ maskName(item.nickname) }}</div>  
                                <div class="name-value">
                                    <el-rate
                                    style="--el-rate-disabled-icon-color: #f2cb0b;"
                                        v-model="value"
                                        disabled
                                        text-color="#FC7702"
                                        v-if="isMobile==false"
                                    />
                                    <div v-else><img style="width: 20px;height: 20px;" src="../../../assets/images/collects1.png" alt=""></div>
                                   <div style="padding-left: 4px;"> 4.0</div>
                                   <div class="line" ></div>
                                   <div class="fans">Fans：<span>4K</span></div>
                                   <div class="line"></div>
                                   <div class="fans">Sold：<span>10W</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="setup"  v-if="isMobile==false">
                            <div class="but no" @click="Addfollow(item, i)" v-if="item.but == false">{{$t('home7')}}</div>
                            <div class="but yes" @click="delfollow(item, i)" v-else>{{$t('home27')}}</div>
                        </div>
                        <div class="setup"  v-else>
                            <img src="../../../assets/images/noguanzhu.png" style="width: 28px;height: 28px;" alt="" srcset="" @click="Addfollow(item, i)" v-if="item.but == false"/>
                            <img src="../../../assets/images/guanzhu.png" style="width: 28px;height: 28px;" alt="" srcset="" @click="delfollow(item, i)" v-else/>
                        </div>
                    </div>
                </div>
                <p v-if="loading" style="    padding: 30px;text-align: center;">Loading...</p>
                <p v-if="noMore" style="    padding: 30px;text-align: center;">No more</p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

.el-rate {
    // --el-rate-void-color: #dadee8;
    --el-rate-height: 20px;
    // --el-rate-font-size: var(--el-font-size-base);
    --el-rate-icon-size: 21px;
    --el-rate-icon-margin: -2px;
    // --el-rate-void-color: var(--el-border-color-darker);
    --el-rate-fill-color: #FC7702;
    // --el-rate-disabled-void-color: var(--el-fill-color);
    // --el-rate-text-color: var(--el-text-color-primary);
    /* 使用深度选择器 */
        // ::v-deep .el-rate__item.is-disabled.is-active {
        // background: none; /* 移除默认的背景 */
        // border: 1px solid #FC7702; /* 设置边框颜色 */
        // }
}

.historyPage {
    width: 100%;
    height: 100%;

    .home-panel {
        background-color: #fff;
        padding: 20px 20px 20px 20px;
        height: 100%;
        border-radius: 8px;


        .header {
            // height: 66px;
            // border-bottom: 1px solid #f5f5f5;
            // padding: 18px 0;
            padding-top: 11px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            .header-title{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #11192D;
                line-height: 18px;
                text-align: left;
                font-style: normal;
            }
            // h4 {
            //     font-size: 22px;
            //     font-weight: 400;
            // }

        }

        .goods-list {
            .list-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                // height: 80px;
                padding: 14px 0;
                border-bottom: 1px solid #E5E8EC;
                .item-user {
                    display: flex;
                    align-items: center;

                    .avatar-container {
                        display: inline-block;
                        /* 或者使用 block，取决于你的布局需求 */
                        text-align: center;

                        /* 如果需要居中显示 */
                        .avatar {
                            width: 60px;
                            /* 设置头像的宽度 */
                            height: 60px;
                            /* 设置头像的高度 */
                            border-radius: 50%;
                            /* 设置圆角，使其看起来像圆形 */
                            object-fit: cover;
                            /* 确保图片内容被裁剪以适应容器 */
                            border: 2px solid #fff;
                            /* 添加白色边框 */
                            box-shadow: 0 5px 4px rgba(0, 0, 0, 0.2);
                            /* 添加阴影以增加立体感 */
                        }
                    }

                    .name {
                        // padding-right: 16px;
                        margin-left: 16px;
                        .name-title{
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #11192D;
                        line-height: 21px;
                        text-align: left;
                        font-style: normal;
                        }
                        .name-value{
                            display: flex;align-items: center;color: #FC7702;
                            .line{
                            width: 1px;height: 11px;border: 1px solid #D6D6D6;margin: 0 10px;
                            }
                            .fans{
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                color: #888888;
                                line-height: 19px;
                                text-align: left;
                                font-style: normal; 
                                span{
                                    color: #333333;
                                }
                            }
                        }
                        
                    }


                }

                .setup {
                    .but {
                        width: 118px;
                        height: 36px;
                        
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                       
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                    }

                    .yes {
                        background: #FF5555;
                        color: #FFFFFF;
                    }

                    .no {
                        border: 1px solid #E1E1E1;
                        background: #FFFFFF;
                        color: #666666;
                    }
                }
            }
        }
    }

}

@media (max-width: 768px) {
    
    .historyPage {
        width: 100%;
        height: 100%;

    .home-panel {
        background-color: #fff;
        padding: 55px  20px 20px 20px;
        // margin-top: 67px;
        // padding-top: 55px;

        .MyFollowers{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            text-align: left;
            font-style: normal;
        }
        .header {
            // height: 66px;
            // border-bottom: 1px solid #f5f5f5;
            // padding: 18px 0;
            padding-top: 11px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            .header-title{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #11192D;
                line-height: 18px;
                text-align: left;
                font-style: normal;
            }
            // h4 {
            //     font-size: 22px;
            //     font-weight: 400;
            // }

        }

        .goods-list {
            .list-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                // height: 80px;
                padding: 15px 0;
                border-bottom: 0px solid #E5E8EC;
                .item-user {
                    display: flex;
                    align-items: center;

                    .avatar-container {
                        display: inline-block;
                        /* 或者使用 block，取决于你的布局需求 */
                        text-align: center;

                        /* 如果需要居中显示 */
                        .avatar {
                            width: 54px;
                            /* 设置头像的宽度 */
                            height: 54px;
                            /* 设置头像的高度 */
                            border-radius: 50%;
                            /* 设置圆角，使其看起来像圆形 */
                            object-fit: cover;
                            /* 确保图片内容被裁剪以适应容器 */
                            border: 2px solid #fff;
                            /* 添加白色边框 */
                            box-shadow: 0 5px 4px rgba(0, 0, 0, 0.2);
                            /* 添加阴影以增加立体感 */
                        }
                    }

                    .name {
                        // padding-right: 16px;
                        margin-left: 16px;
                        .name-title{
                            font-family: MicrosoftYaHei, MicrosoftYaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #11192D;
                            line-height: 21px;
                            text-align: left;
                            font-style: normal;
                        }
                        .name-value{
                            display: flex;align-items: center;color: #FC7702;
                            .line{
                                width: 1px;height: 11px;border: 1px solid #D6D6D6;margin: 0 10px;
                            }
                            .fans{
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                color: #888888;
                                line-height: 19px;
                                text-align: left;
                                font-style: normal; 
                                span{
                                    color: #333333;
                                }
                            }
                        }
                    }


                }

                .setup {
                    .but {
                        width: 118px;
                        height: 36px;
                        
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                       
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                    }

                    .yes {
                        background: #FF5555;
                        color: #FFFFFF;
                    }

                    .no {
                        border: 1px solid #E1E1E1;
                        background: #FFFFFF;
                        color: #666666;
                    }
                }
            }
        }
    }

}
}
</style>